import { render, staticRenderFns } from "./VtSidePanel.vue?vue&type=template&id=6ffefb6a&scoped=true&"
import script from "./VtSidePanel.vue?vue&type=script&lang=js&"
export * from "./VtSidePanel.vue?vue&type=script&lang=js&"
import style0 from "./VtSidePanel.vue?vue&type=style&index=0&id=6ffefb6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffefb6a",
  null
  
)

export default component.exports